import React from 'react'
import MasterCardImg from '../../../assets/icons/master-card-icon.png'
import MasterCardImgPb from '../../../assets/icons/master-card-pb-icon.png'
import { StyledIcon } from './styled-icon.style'

/**
 * @param {boolean} disabled
 * if true, set the img to black and white
 */
const MasterCardIcon = ({ disabled, className }) => (
	<StyledIcon className={className}>
		<img src={disabled ? MasterCardImgPb : MasterCardImg} />
	</StyledIcon>
)

export default MasterCardIcon
